import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    beYouLoading: false,
};

const BeYouSlice = createSlice({
    name: "beYou",
    initialState,
    reducers: {
        setBeYouLoading: (state, action) => {
            state.beYouLoading = action.payload;
        },
    },
});

export const { setBeYouLoading } = BeYouSlice.actions;

export default BeYouSlice.reducer;
